import { render, staticRenderFns } from "./variables.vue?vue&type=template&id=0770f7c1&scoped=true&"
import script from "./variables.vue?vue&type=script&lang=js&"
export * from "./variables.vue?vue&type=script&lang=js&"
import style0 from "./variables.vue?vue&type=style&index=0&id=0770f7c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0770f7c1",
  null
  
)

export default component.exports